import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';

export async function getPropertyServiceEligibility(
  claimNumber: string,
  urlKey: string,
  sessionId: string,
  custKey: string,
  zipCode: string
) {
  try {
    const headers = new Headers();
    const bodyData = {
      zipCode: zipCode,
    };
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}${claimNumber}/propertyeligibleservices`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData),
    });
    if (response && response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      if (responseData.response.status.code === 200) {
        return responseData;
      } else {
        throw new Error("'propertyeligibleservices' failed");
      }
    } else {
      throw new Error("'propertyeligibleservices' failed");
    }
  } catch (error) {
    return null;
  }
}

export async function getAutoServiceEligibility(
  claimNumber: string,
  urlKey: string,
  sessionId: string,
  custKey: string,
  vin: string
) {
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}claims/${claimNumber}/${vin}`;
    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;

    if (_get(responseData, 'response.status.code', '') >= 200) {
      return responseData;
    } else {
      return { error, statusCode, message };
    }
  } catch (error) {
    console.log('getAutoServiceEligibility:error', error);
    return error;
  }
}
